import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-review-form-findings',
  templateUrl: './review-form-findings.component.html',
  styleUrl: './review-form-findings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormFindingsComponent {
  public form = input.required<FormGroup>();
  public required = input<boolean>(false);
}
